module.exports = __webpack_public_path__ + "img/girl_left.118dafb2.svg";